<template>
  <span
    class="inline-flex items-center shrink-0"
    :class="showLabel ? 'gap-1.5' : ''"
  >
    <svg
      width="64"
      height="57"
      viewBox="0 0 64 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="shrink-0"
      :class="svgSizeClass"
      role="img"
      :aria-label="ariaLabel"
    >
      <g :filter="`url(#${filterId})`">
        <path
          d="M47.0288 23.5738C46.7163 23.0831 46.4181 22.62 46.2975 22.1688C46.1694 21.6894 46.1938 21.1225 46.2194 20.5225C46.2563 19.6525 46.295 18.7531 45.8581 17.9981C45.4144 17.2313 44.6081 16.8106 43.8306 16.41C43.3038 16.1363 42.8056 15.8781 42.4638 15.535C42.1219 15.1919 41.8638 14.695 41.5888 14.1681C41.1875 13.3906 40.7688 12.5856 40 12.1419C39.2456 11.7044 38.3456 11.7437 37.4756 11.7806C36.8756 11.8062 36.3088 11.8306 35.8294 11.7025C35.3781 11.5819 34.915 11.285 34.4244 10.9713C33.68 10.4938 32.9088 10 32 10C31.0913 10 30.32 10.4938 29.5738 10.9713C29.0831 11.2838 28.62 11.5819 28.1688 11.7025C27.6875 11.8306 27.125 11.8062 26.5225 11.7806C25.6525 11.7437 24.7531 11.705 23.9981 12.1419C23.2313 12.5856 22.8106 13.3919 22.41 14.1694C22.1363 14.6963 21.8781 15.1944 21.535 15.5363C21.1919 15.8781 20.695 16.1363 20.1681 16.4113C19.3906 16.8125 18.5856 17.2313 18.1419 18C17.7044 18.7544 17.7437 19.6544 17.7806 20.5244C17.8062 21.1244 17.8306 21.6913 17.7025 22.1706C17.5819 22.6219 17.285 23.085 16.9713 23.5756C16.4938 24.32 16 25.0913 16 26C16 26.9088 16.4938 27.68 16.9713 28.4263C17.2838 28.9169 17.5819 29.38 17.7025 29.8312C17.8306 30.3125 17.8062 30.875 17.7806 31.4775C17.7437 32.3475 17.705 33.25 18.1419 34C18.5856 34.7669 19.3919 35.1875 20.1694 35.5881C20.6963 35.8619 21.1944 36.12 21.5363 36.4631C21.8781 36.8063 22.1363 37.3031 22.4113 37.83C22.8125 38.6094 23.2313 39.4144 24 39.8581C24.7544 40.2956 25.6544 40.2563 26.5244 40.2194C27.1244 40.1938 27.6913 40.1694 28.1706 40.2975C28.6219 40.4181 29.085 40.715 29.5756 41.0288C30.32 41.5063 31.0913 42 32 42C32.9088 42 33.68 41.5063 34.4263 41.0288C34.9169 40.7163 35.38 40.4181 35.8312 40.2975C36.3106 40.1694 36.8775 40.1938 37.4775 40.2194C38.3475 40.2563 39.2469 40.295 40.0019 39.8581C40.7688 39.4144 41.1894 38.6081 41.59 37.8306C41.8638 37.3038 42.1219 36.8056 42.465 36.4638C42.8081 36.1219 43.305 35.8638 43.8319 35.5888C44.6094 35.1875 45.4144 34.7688 45.8581 34C46.2956 33.2456 46.2563 32.3456 46.2194 31.4756C46.1938 30.8756 46.1694 30.3088 46.2975 29.8294C46.4181 29.3781 46.715 28.915 47.0288 28.4244C47.5063 27.68 48 26.9088 48 26C48 25.0913 47.5063 24.32 47.0288 23.5738Z"
          :fill="theme.fill"
        />
        <g :clip-path="`url(#${clipId})`">
          <path
            d="M33.2093 20.0263L34.4412 22.5026C34.6092 22.8474 35.0571 23.178 35.4351 23.2413L37.6679 23.6142C39.0957 23.8534 39.4317 24.8946 38.4028 25.9217L36.667 27.6664C36.373 27.9619 36.212 28.5317 36.303 28.9397L36.7999 31.0995C37.1919 32.809 36.289 33.4703 34.7842 32.5769L32.6914 31.3317C32.3134 31.1066 31.6905 31.1066 31.3056 31.3317L29.2128 32.5769C27.715 33.4703 26.8051 32.802 27.197 31.0995L27.694 28.9397C27.7849 28.5317 27.624 27.9619 27.33 27.6664L25.5942 25.9217C24.5723 24.8946 24.9013 23.8534 26.3291 23.6142L28.5619 23.2413C28.9328 23.178 29.3808 22.8474 29.5487 22.5026L30.7806 20.0263C31.4525 18.6826 32.5444 18.6826 33.2093 20.0263Z"
            :fill="theme.star"
          />
        </g>
      </g>
      <defs>
        <filter
          :id="filterId"
          x="0"
          y="0"
          width="64"
          height="64"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood
            flood-opacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6" />
          <feGaussianBlur stdDeviation="8" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0509804 0 0 0 0 0.0588235 0 0 0 0 0.0823529 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <clipPath :id="clipId">
          <rect
            width="15.0598"
            height="15.0598"
            fill="white"
            transform="translate(24.4707 18.4708)"
          />
        </clipPath>
      </defs>
    </svg>
    <span
      v-if="showLabel"
      class="font-semibold leading-none whitespace-nowrap"
      :class="labelSizeClass"
      :style="{ color: theme.label }"
      >{{ label }}</span
    >
  </span>
</template>

<script setup lang="ts">
import { getAgentTierIconTheme } from '~/constants/agentTiers';

const props = withDefaults(defineProps<{ tier: string; size?: 'sm' | 'md' | 'lg'; showLabel?: boolean }>(), {
  size: 'md',
  showLabel: true,
});

const { t } = useI18n();
const { tierLabel } = useAgentTierLabel();

const uid = useId();
const filterId = `agent-tier-f-${uid}`;
const clipId = `agent-tier-c-${uid}`;

const label = computed(() => tierLabel(props.tier));
const theme = computed(() => getAgentTierIconTheme(props.tier));
const ariaLabel = computed(() => t('rankings.tiers.ariaLabel', { tier: label.value }));

const svgSizeClass = computed(() => {
  const map = { sm: 'h-9 w-10', md: 'h-11 w-[50px]', lg: 'h-14 w-16' } as const;
  return map[props.size];
});

const labelSizeClass = computed(() => {
  const map = { sm: 'text-[11px]', md: 'text-xs', lg: 'text-sm' } as const;
  return map[props.size];
});
</script>
